function ModalAllFiltersInit(firstInit) {
    document.querySelectorAll('.ModalAllFilters__group').forEach((group) => {
        group.querySelectorAll('.SelectBase').forEach(SelectBaseInit);
        group.querySelectorAll('.ToggleBase').forEach(ToggleBaseInit);
        group.querySelectorAll('.ToggleBoolean').forEach(ToggleBooleanInit);
        group.querySelectorAll('.ToggleBoolean').forEach(ToggleBooleanInit);
        group.querySelectorAll('.CheckboxTab').forEach(CheckboxTabInit);
    });
    if(!firstInit) {
        filtersMainInit(document.querySelector('.ModalAllFilters'));
    }
}

setTimeout(() => {
    ModalAllFiltersInit(true);
}, 1);
